__webpack_require__.p = "/manage2/";